import React from 'react';

import { Programme } from '../../../../types/entity.types';

import useTheme from '../../../../hooks/use-theme/useTheme';

import { formatProgrammeDates, getClassNames } from '../../../../utils/util';

import AuthLayout from '../../../../layouts/auth/AuthLayout';

import './registration.scss';

type Props = {
  programmes?: Programme[];
  navigateToProgramme: (externalReference: string) => void;
};

const Registration = ({ programmes = [], navigateToProgramme }: Props) => {
  const { pps } = useTheme();

  return (
    <AuthLayout smallLogo>
      <section className="registration">
        {programmes.length > 0 ? (
          <>
            <p className={getClassNames('registration__question', { pps })}>
              Which programme would you like to register for?
            </p>
            <ul className={getClassNames('registration__programmes', { pps })}>
              {programmes.map((programme) => (
                <li key={programme.externalReference}>
                  <button
                    className={getClassNames('registration__programme', { pps })}
                    onClick={() => navigateToProgramme(programme.externalReference as string)}
                  >
                    <div className="registration__programme__details">
                      <p className="registration__programme__name">{programme.name}</p>
                      <p className="registration__programme__dates">
                        {formatProgrammeDates(programme.fromDate, programme.toDate)}
                      </p>
                    </div>
                    <p className="registration__programme__price">{`R${programme.registrationRequirement?.programmePrice}`}</p>
                  </button>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p className={getClassNames('registration__no-programmes', { pps })}>
            There are no programmes available at the moment.
          </p>
        )}
      </section>
    </AuthLayout>
  );
};

export default Registration;
